export function jsonToString(json) {
  return JSON.stringify(json);
}

export function stringToJson(string) {
  return JSON.parse(string);
}